module.exports = __webpack_public_path__ + "static/media/crow.24073405.jpg";